enum SizeType {
  STRIP = 'strip',
  LANDSCAPE = 'landscape',
  SQUARE = 'square',
  PORTRAIT = 'portrait',
  LANE = 'lane',
}
export { SizeType };
